import React from "react";

const Indicator = ({ indicator }) => (
  <div className={`indicator ${indicator}`}></div>
);

export default Indicator;
